// Wrap axios
import axios from 'axios';
import { store, persistor } from 'Store/index';
import { isPublicPage } from './utilityFunctions';
import { PATHS } from './PagePaths';
import { config } from './config';



const LOCAL_ENV = "http://localhost:8880";
//const ENV = "https://10.101.3.22:8880";
const HTTPS = "https://";
const PORT = ":8880";

// Instance
// Config the baseURL based on the env
const http = axios.create({
  //baseURL: ENV,
  baseURL: config.baseUrl,
  /***!!! local only */
  //baseURL: HTTPS + window.location.hostname + PORT,
  timeout: 20000
});



// header config for json
//http.defaults.headers.post['Content-Type'] = 'application/json';

// header config for form data
//http.defaults.headers.post['Content-Type'] = 'multipart/form-data';

// request interceptor: inject token
http.interceptors.request.use((config) => {
//console.log(window.location.pathname);
  //const token = localStorage.getItem("persist:root");
  //console.log("print out api request interceptor", config, config.headers["Authorization"], window.location.href);

  //console.log(config);
  //token is empty and private page
  if (config.headers["Authorization"] == "Bearer " && isPublicPage(window.location) == false) { //!window.location.href.includes("publicpages")) { 

    // "" is a public page
    if (window.location.pathname !== ''
      && !window.location.pathname.includes("activation")
      && !window.location.pathname.includes("password/token")
      && !window.location.pathname.includes("/token")) {

      window.location.href = PATHS.public['Sign In']
      return config;
    }
  }

  //token is not empty but expired when open a new tab
  if (localStorage.getItem("token")) {
    config.headers["Authorization"] = "Bearer " + localStorage.getItem("token");
  }

  return config;
}, (error) => {
  //console.log(error);
  return Promise.reject(error)
});

// Response interceptor
http.interceptors.response.use((response) => {
  const loginInfo = store.getState().loginInfo;
  //console.log("interceptors.response", loginInfo, response, response.headers["authorization"]);

  if (response.headers["authorization"]) {
    localStorage.setItem("token", response.headers["authorization"]);
  }

  /*if(response.data.status==-15){
      //console.log(" unauth");
      const error = new Error("message")
      error.code = 401;
      throw error;
      
      //window.location.href = '/login';
      
  }*/
  return response.data;

}, (error) => {

  console.dir(error);

  /*if (error.response.status === 401) {
    //console.log(error);
    //console.log('Unauthorized');
    // or use history to replace browser router
    
        
    window.location.href = '/login';
    
  }*/

  return Promise.reject(error)
})

//export { http, LOCAL_ENV, ENV }
export { http }